export default __webpack_public_path__ + "static/media/sheep-with-coins.a0bb29e2.svg";